import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { useTypedSelector } from './useTypedSelector';
import {
    IUtmSection,
    UTM_SECTIONS_REPORT_PATHNAME,
    injectUtmSectionsIntoFilters,
    normalizeUtmSections,
} from '../../../helpers/utils/utmSections';

const EMPTY_SECTIONS: IUtmSection[] = [];

/**
 * Справочник секций разобранных UTM-меток («Параметры Яндекс.Директ») из redux
 * (`state.table.utmSections`). Секции глобальные (не блочные), как и «Группы регистраций».
 *
 * Показываем ТОЛЬКО в отчёте рекламы: вне `/users/ad-reports` хук отдаёт пустой список,
 * и все потребители дерева фильтров (в т.ч. плюсик «добавить в фильтр» в строке отчёта)
 * секций не видят.
 */
export const useUtmSections = (): IUtmSection[] => {
    const { pathname } = useLocation();
    const utmSections = useTypedSelector((state) => state.table.utmSections);
    const isAdReport = pathname === UTM_SECTIONS_REPORT_PATHNAME;

    return useMemo(
        () => (isAdReport ? normalizeUtmSections(utmSections) : EMPTY_SECTIONS),
        [ utmSections, isAdReport ]
    );
};

/**
 * Дерево фильтров с достроенными секциями разобранных UTM-меток.
 * @param baseData исходное дерево (статическое из `constants/filters` или уже модифицированное)
 */
export const useFiltersWithUtmSections = (baseData: any[]): any[] => {
    const sections = useUtmSections();

    return useMemo(
        () => injectUtmSectionsIntoFilters(baseData, sections),
        [ baseData, sections ]
    );
};
